import { useQuery } from "@tanstack/react-query";

import { getAttendanceRoster } from "@/api/checkin";

export function useAttendanceRoster(
  churchId: string | null,
  serviceOccurrenceId: string | undefined,
) {
  return useQuery({
    queryKey: ["attendance-roster", churchId, serviceOccurrenceId],
    enabled: !!churchId && !!serviceOccurrenceId,
    queryFn: () => getAttendanceRoster(churchId!, serviceOccurrenceId!),
  });
}